module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    ref: "bartwo",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "bartwoMain"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7684ca50","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/bulletin/BarTwoChart.vue
// module id = 1575
// module chunks = 0